var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.isAllowed)?_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('span',_vm._g(_vm._b({},'span',attrs,false),on),[_vm._t("default",null,{"isDisabled":!_vm.isAllowed})],2)]}}],null,true)},[_c('span',[_vm._v("Sin Permiso")])]):_vm._t("default",null,{"isDisabled":!_vm.isAllowed})],2)}
var staticRenderFns = []

export { render, staticRenderFns }